const mapComponent = document.querySelector('.pricemap-component');
if(mapComponent) {
    import(
        /* webpackChunkName: "pricemap-component" */
        /* webpackMode: "lazy" */
        './map.js'
    );
}
